import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';

export default class DebouncedSearchField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value,
        };

        this.publishChange = () => {};
        this.handleChange = this.handleChange.bind(this);

        this.createDebouncer(this.props.onChange, this.props.debounceWait);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState(() => ({
            value: nextProps.value,
        }));

        if (this.props.onChange !== nextProps.onChange) {
            this.createDebouncer(nextProps.onChange, nextProps.debounceWait);
        }
    }

    componentWillUnmount() {
        if (this.publishChange.cancel) {
            this.publishChange.cancel();
        }
    }

    handleChange({ target }) {
        this.setState(
            () => ({
                value: target.value,
            }),
            () => {
                this.publishChange(this.props.name, this.state.value);
            }
        );
    }

    createDebouncer(fn = () => {}, wait) {
        if (this.publishChange.cancel) {
            this.publishChange.cancel();
        }

        // Disable debouncing in tests
        if (wait > 0) {
            this.publishChange = debounce(fn, wait, { leading: false });
        } else {
            this.publishChange = fn;
        }
    }

    render() {
        return this.props.render({
            value: this.state.value,
            onChange: this.handleChange,
        });
    }
}

DebouncedSearchField.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    debounceWait: PropTypes.number,
    render: PropTypes.func.isRequired,
};

DebouncedSearchField.defaultProps = {
    value: '',
    onChange: () => {},
    debounceWait: 500,
};



// WEBPACK FOOTER //
// ./src/js/components/DebouncedSearchField.jsx